import styled from 'styled-components';
import RetrySvg from '@sdk/assets/svg/UI/retry-gray.svg';
import BaseIconSvg from '@sdk/components/ui/BaseIconSvg';

export const RetryIcon = styled(BaseIconSvg)``;
RetryIcon.defaultProps = {
  as: RetrySvg,
};

export const Button = styled.button`
  align-items: center;
  background: transparent;
  border: 0;
  border-radius: 0;
  color: ${({ theme }) => theme.colors.iconGray};
  cursor: pointer;
  display: flex;
  height: 24px;
  justify-content: center;
  min-width: 24px;
  padding: 0;
  pointer-events: auto;
`;
